<mat-card class="content-card">
    <app-file-upload *appHasRoles="['admin']"  (upload)="onUpload($event)"></app-file-upload>
    <app-mat-table-generator #table
        tableName="cardCreationsImportsTable"
        [columns]="columns"
        [dataSource]="dataSource"
        [multiselectEnabled]="multiselectEnabled()"
        [viewLink]="getViewLink"
        [useEmbededFilter]="false"
        [rowClassCallback]="getRowClass"
        [deleteEnabled]="deleteEnabled()">
    </app-mat-table-generator>
</mat-card>
